import React, { Component, Fragment } from "react";

import {
    Grid,
    Typography,
    TextField,
    Checkbox,
    FormControlLabel,
    Button,
    Chip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from "@material-ui/core";

import SignatureCanvas from "../../components/sigpad/SignatureCanvas";
import GooglePlaceAutoComplete from "../../components/maps/GooglePlaceAutocomplete";

const HOT_PINK = "#fe0d9d";

const SectionTitle = ({ children }) => (
    <Grid item xs={12}>
        <Typography
            variant="subheading"
            style={{
                fontWeight: 700,
                color: "#1f2430",
                display: "flex",
                alignItems: "center",
                gap: 8,
                marginTop: 8
            }}
        >
            {children}
        </Typography>
    </Grid>
);

class EmployerSuperSetup extends Component {
    static buildSearchedAddress(v) {
        const street = v.regStreet || "";
        const suburb = v.regSuburb || "";
        const state = v.regState || "";
        const postcode = v.regPostcode || "";
        if (!street && !suburb && !state && !postcode) return "";
        return `${street}, ${suburb}, ${state}, ${postcode}`;
    }

    constructor(props) {
        super(props);
        const v = props.initialValues || {};
        this.state = {
            employerRegistered: v.employerRegistered || false,
            onboardedAtClearingHouse: v.onboardedAtClearingHouse || false,
            detailsSyncedAtClearingHouse: v.detailsSyncedAtClearingHouse || null,
            companyName: v.companyName || "",
            abn: v.abn || "",
            contactFirstName: v.contactFirstName || "",
            contactLastName: v.contactLastName || "",
            contactEmail: v.contactEmail || "",
            contactMobile: v.contactMobile || "",
            contactAreaCode: v.contactAreaCode || "",
            contactTelephone: v.contactTelephone || "",
            searchedAddress: EmployerSuperSetup.buildSearchedAddress(v),
            regStreet: v.regStreet || "",
            regSuburb: v.regSuburb || "",
            regState: v.regState || "",
            regPostcode: v.regPostcode || "",
            contribBSB: v.contribBSB || "",
            contribAccountNumber: v.contribAccountNumber || "",
            contribAccountName: v.contribAccountName || "",
            sameAsContrib: v.sameAsContrib !== undefined ? v.sameAsContrib : true,
            refundBSB: v.refundBSB || "",
            refundAccountNumber: v.refundAccountNumber || "",
            refundAccountName: v.refundAccountName || "",
            directDebitAgreed: v.directDebitAgreed || false,
            signatoryName: v.signatoryName || "",
            signatoryPosition: v.signatoryPosition || "",
            signatureDataUrl: v.signatureDataUrl || "",
            tcDialogOpen: false,
            confirmDialogOpen: false,
            isSubmitting: false,
            submitError: null,
            submitted: false,
            touched: {},
        };
        this.sigPad = null;
        this.fileInput = null;
    }

    componentDidMount() {
        if (this.props.onStatusChange) {
            this.props.onStatusChange(this.state.employerRegistered, this.state.companyName);
        }
    }

    set = (field) => (e) => {
        this.setState({ [field]: e.target.value });
    };

    touch = (field) => () => {
        this.setState(prev => ({ touched: { ...prev.touched, [field]: true } }));
    };

    handleChangeSearchAddress = value => {
        this.setState({ searchedAddress: value });
    };

    handleChangeLongitudeLatitude = () => {};

    handleChangeStreet = e => {
        this.setState({ regStreet: e.target.value });
    };

    handleChangeCity = e => {
        this.setState({ regSuburb: e.target.value });
    };

    handleChangePostal = e => {
        this.setState({ regPostcode: e.target.value });
    };

    handleChangeState = e => {
        this.setState({ regState: e.target.value });
    };

    setAbn = (e) => {
        this.setState({ abn: e.target.value.replace(/\s/g, "") });
    };

    abnError = () => {
        const raw = (this.state.abn || "").replace(/\s/g, "");
        if (!raw) return "ABN is required";
        if (!/^[0-9]{11}$/.test(raw)) return "ABN must be exactly 11 digits";
        const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
        const digits = raw.split("").map(Number);
        digits[0] -= 1;
        const sum = digits.reduce((acc, d, i) => acc + d * weights[i], 0);
        if (sum % 89 !== 0) return "ABN is invalid";
        return "";
    };

    handleSameAsContrib = (e) => {
        const checked = e.target.checked;
        this.setState({
            sameAsContrib: checked,
            ...(checked
                ? {
                      refundBSB: this.state.contribBSB,
                      refundAccountNumber: this.state.contribAccountNumber,
                      refundAccountName: this.state.contribAccountName
                  }
                : {})
        });
    };

    handleContribChange = (field, refundField) => (e) => {
        const isNumericField = field === "contribBSB" || field === "contribAccountNumber";
        const value = isNumericField ? e.target.value.replace(/\D/g, "") : e.target.value;

        this.setState({
            [field]: value,
            ...(this.state.sameAsContrib ? { [refundField]: value } : {})
        });
    };

    handleClearSignature = () => {
        if (this.sigPad) {
            this.sigPad.clear();
        }
        this.setState({ signatureDataUrl: "" });
    };

    handleSignatureEnd = () => {
        if (this.sigPad && !this.sigPad.isEmpty()) {
            this.setState({ signatureDataUrl: this.sigPad.getTrimmedCanvas().toDataURL("image/png") });
        }
    };

    handleUploadClick = () => {
        if (this.fileInput) this.fileInput.click();
    };

    handleUploadFile = (e) => {
        const file = e.target.files && e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (ev) => {
            this.setState({ signatureDataUrl: ev.target.result });
        };
        reader.readAsDataURL(file);
    };

    mobileError = () => {
        const v = this.state.contactMobile;
        if (!v) return "Mobile phone is required";
        if (!/^04[0-9]{8}$/.test(v)) return "Must be 10 digits starting with 04 (e.g. 0452624731)";
        return "";
    };

    telephoneError = () => {
        const v = this.state.contactTelephone;
        if (!v) return "Telephone is required";
        if (!/^[0-9]{10}$/.test(v)) return "Must be exactly 10 digits (e.g. 0452624731)";
        return "";
    };

    validate = () => {
        const s = this.state;
        const errors = [];
        if (!s.companyName) errors.push("Company name is required");
        const abnErr = this.abnError();
        if (abnErr) errors.push(abnErr);
        if (!s.contactFirstName) errors.push("First name is required");
        if (!s.contactLastName) errors.push("Last name is required");
        if (!s.contactEmail) errors.push("Email is required");
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s.contactEmail)) errors.push("Email must be a valid email address");
        const mobileErr = this.mobileError();
        if (mobileErr) errors.push(mobileErr);
        if (!s.regStreet) errors.push("Street address is required");
        if (!s.regSuburb) errors.push("Suburb is required");
        if (!s.regState) errors.push("State is required");
        if (!s.regPostcode) errors.push("Postcode is required");
        else if (!/^[0-9]{4}$/.test(s.regPostcode)) errors.push("Postcode must be exactly 4 digits");
        if (!s.contribBSB) errors.push("Direct debit BSB is required");
        else if (!/^[0-9]{6}$/.test(s.contribBSB.replace(/-/g, ""))) errors.push("Direct debit BSB must be exactly 6 digits");
        if (!s.contribAccountNumber) errors.push("Direct debit account number is required");
        if (!s.contribAccountName) errors.push("Direct debit account name is required");
        if (!s.sameAsContrib) {
            if (!s.refundBSB) errors.push("Refund BSB is required");
            else if (!/^[0-9]{6}$/.test(s.refundBSB.replace(/-/g, ""))) errors.push("Refund BSB must be exactly 6 digits");
            if (!s.refundAccountNumber) errors.push("Refund account number is required");
            if (!s.refundAccountName) errors.push("Refund account name is required");
        }
        if (!s.signatoryName) errors.push("Signatory name is required");
        if (!s.signatoryPosition) errors.push("Signatory position is required");
        if (!s.signatureDataUrl) errors.push("Signature is required");
        if (!s.directDebitAgreed) errors.push("You must agree to the direct debit terms");
        return errors;
    };

    isComplete = () => {
        const s = this.state;
        return Boolean(
            s.companyName &&
                !this.abnError() &&
                s.contactFirstName &&
                s.contactLastName &&
                s.contactEmail &&
                !this.mobileError() &&
                s.regStreet &&
                s.regSuburb &&
                s.regState &&
                s.regPostcode &&
                s.contribBSB &&
                s.contribAccountNumber &&
                s.contribAccountName &&
                s.signatoryName &&
                s.signatoryPosition &&
                s.signatureDataUrl &&
                s.directDebitAgreed
        );
    };

    handleRegister = async () => {
        this.setState({ submitted: true });
        const validationErrors = this.validate();
        if (validationErrors.length > 0) {
            this.setState({ submitError: validationErrors.join(", ") });
            return;
        }
        this.setState({ isSubmitting: true, submitError: null });
        try {
            if (this.props.onRegister) {
                await this.props.onRegister(this.state);
            }
            this.setState({ employerRegistered: true, isSubmitting: false });
            if (this.props.onStatusChange) {
                this.props.onStatusChange(true, this.state.companyName);
            }
        } catch (e) {
            const rawErrors = e?.response?.data?.errors;
            let submitError;
            if (rawErrors && typeof rawErrors === "object" && !Array.isArray(rawErrors)) {
                submitError = Object.values(rawErrors)
                    .flat()
                    .join(", ");
            } else {
                submitError = rawErrors || e?.message || "Registration failed. Please try again.";
            }
            this.setState({ isSubmitting: false, submitError });
        }
    };

    render() {
        const s = this.state;
        return (
            <React.Fragment>
            <div
                style={{
                    background: "#fff",
                    border: "1px solid #e9eaee",
                    borderRadius: 14,
                    padding: 24
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: 18
                    }}
                >
                    <Typography variant="title" style={{ fontWeight: 700, fontSize: 18 }}>
                        Employer Super Setup
                    </Typography>
                    <Chip
                        label={
                            !s.employerRegistered ? "Not Registered"
                            : (s.onboardedAtClearingHouse && (s.detailsSyncedAtClearingHouse === "true" || s.detailsSyncedAtClearingHouse === "NA")) ? "Active"
                            : "Submitted - Awaiting Verification"
                        }
                        style={{
                            backgroundColor:
                                !s.employerRegistered ? "#9e9e9e"
                                : (s.onboardedAtClearingHouse && (s.detailsSyncedAtClearingHouse === "true" || s.detailsSyncedAtClearingHouse === "NA")) ? "#15a36a"
                                : "#1976d2",
                            color: "#fff",
                            fontWeight: 600,
                            height: 26
                        }}
                    />
                </div>

                <Grid container spacing={16}>
                    <SectionTitle>Employer Details</SectionTitle>
                    <Grid item xs={12} md={6}>
                        <TextField required label="Trading / Company Name" margin="dense" fullWidth value={s.companyName} onChange={this.set("companyName")} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            required
                            label="ABN"
                            margin="dense"
                            fullWidth
                            value={s.abn}
                            onChange={this.setAbn}
                            onBlur={this.touch("abn")}
                            error={(s.submitted || s.touched.abn) && !!this.abnError()}
                            helperText={(s.submitted || s.touched.abn) ? (this.abnError() || "11 digits, no spaces") : "11 digits, no spaces"}
                        />
                    </Grid>

                    <SectionTitle>Contact Person</SectionTitle>
                    <Grid item xs={12} md={6}>
                        <TextField required label="First Name" margin="dense" fullWidth value={s.contactFirstName} onChange={this.set("contactFirstName")} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField required label="Last Name" margin="dense" fullWidth value={s.contactLastName} onChange={this.set("contactLastName")} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField required label="Email" type="email" margin="dense" fullWidth value={s.contactEmail} onChange={this.set("contactEmail")} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            required
                            label="Mobile Phone"
                            margin="dense"
                            fullWidth
                            value={s.contactMobile}
                            onChange={this.set("contactMobile")}
                            onBlur={this.touch("contactMobile")}
                            error={(s.submitted || s.touched.contactMobile) && !!this.mobileError()}
                            helperText={(s.submitted || s.touched.contactMobile) ? (this.mobileError() || "Required — must start with 04, 10 digits (e.g. 0452624731). For mobile phones, please add 61") : "Required — must start with 04, 10 digits (e.g. 0452624731). For mobile phones, please add 61"}
                            inputProps={{ maxLength: 10 }}
                        />
                    </Grid>

                    <SectionTitle>Registered Address</SectionTitle>
                    <Grid item xs={12}>
                        <GooglePlaceAutoComplete
                            value={s.searchedAddress}
                            label="Search Address"
                            placeholder="Type address to auto-fill fields below"
                            handleChange={this.handleChangeSearchAddress}
                            handleChangeStreet={this.handleChangeStreet}
                            handleChangeCity={this.handleChangeCity}
                            handleChangePostal={this.handleChangePostal}
                            handleChangeState={this.handleChangeState}
                            handleChangeLatLng={this.handleChangeLongitudeLatitude}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField required label="Street" margin="dense" fullWidth value={s.regStreet} onChange={this.set("regStreet")} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField required label="Suburb" margin="dense" fullWidth value={s.regSuburb} onChange={this.set("regSuburb")} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField required label="State" margin="dense" fullWidth value={s.regState} onChange={this.set("regState")} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField required label="Postcode" margin="dense" fullWidth value={s.regPostcode} onChange={this.set("regPostcode")} />
                    </Grid>

                    <SectionTitle>Contribution Bank Account</SectionTitle>
                    <Grid item xs={12} md={4}>
                        <TextField required label="BSB" margin="dense" fullWidth value={s.contribBSB} onChange={this.handleContribChange("contribBSB", "refundBSB")} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField required label="Account Number" margin="dense" fullWidth value={s.contribAccountNumber} onChange={this.handleContribChange("contribAccountNumber", "refundAccountNumber")} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField required label="Account Name" margin="dense" fullWidth value={s.contribAccountName} onChange={this.handleContribChange("contribAccountName", "refundAccountName")} />
                    </Grid>

                    <SectionTitle>Refund Bank Account</SectionTitle>
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={<Checkbox checked={s.sameAsContrib} onChange={this.handleSameAsContrib} color="primary" />}
                            label="Same as contribution account"
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                            <TextField label="BSB" margin="dense" fullWidth disabled={s.sameAsContrib} value={s.refundBSB} onChange={(e) => {
                                e.target.value = e.target.value.replace(/\D/g, '');
                                this.set("refundBSB")(e);
                            }} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField label="Account Number" margin="dense" fullWidth disabled={s.sameAsContrib} value={s.refundAccountNumber} onChange={this.set("refundAccountNumber")} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField label="Account Name" margin="dense" fullWidth disabled={s.sameAsContrib} value={s.refundAccountName} onChange={this.set("refundAccountName")} />
                    </Grid>

                    <Grid item xs={12}>
                        <FormControlLabel
                            control={<Checkbox checked={s.directDebitAgreed} onChange={(e) => this.setState({ directDebitAgreed: e.target.checked })} color="primary" />}
                            label={
                                <span>
                                    I authorise direct debit of my nominated account for superannuation contributions, in accordance with the{" "}
                                    <a
                                        href={process.env.REACT_APP_TOS_URL}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: HOT_PINK, textDecoration: "underline" }}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        Terms &amp; Conditions
                                    </a>
                                </span>
                            }
                        />
                    </Grid>

                    <SectionTitle>Signatory</SectionTitle>
                    <Grid item xs={12} md={6}>
                        <TextField required label="Signatory Name" margin="dense" fullWidth value={s.signatoryName} onChange={this.set("signatoryName")} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            required
                            label="Signatory Position"
                            margin="dense"
                            fullWidth
                            value={s.signatoryPosition}
                            onChange={this.set("signatoryPosition")}
                            onBlur={this.touch("signatoryPosition")}
                            error={(s.submitted || s.touched.signatoryPosition) && !s.signatoryPosition}
                            helperText={(s.submitted || s.touched.signatoryPosition) && !s.signatoryPosition ? "Required" : ""}
                        />
                    </Grid>

                    <SectionTitle>Digital Signature <span style={{ color: "#f44336", marginLeft: 2 }}>*</span></SectionTitle>
                    <Grid item xs={12}>
                        <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
                            <Button
                                variant="contained"
                                size="small"
                                style={{ backgroundColor: HOT_PINK, color: "#fff" }}
                                onClick={() => this.setState({ signatureDataUrl: "" }, () => this.sigPad && this.sigPad.clear())}
                            >
                                Draw
                            </Button>
                            <Button variant="outlined" size="small" onClick={this.handleUploadClick}>
                                Upload Image
                            </Button>
                            <input
                                type="file"
                                accept="image/*"
                                ref={(ref) => (this.fileInput = ref)}
                                style={{ display: "none" }}
                                onChange={this.handleUploadFile}
                            />
                        </div>
                        {s.signatureDataUrl ? (
                            <div
                                style={{
                                    border: "1px solid #e9eaee",
                                    borderRadius: 8,
                                    padding: 10,
                                    display: "inline-block",
                                    background: "#fbfbfc"
                                }}
                            >
                                <img src={s.signatureDataUrl} alt="signature" style={{ maxHeight: 120, maxWidth: "100%" }} />
                            </div>
                        ) : (
                            <Fragment>
                                <Typography variant="caption" style={{ color: "#6b7280", marginBottom: 6, display: "block" }}>
                                    Sign below using your mouse or touch screen
                                </Typography>
                                <div style={{ border: "1px solid #cfd2d8", borderRadius: 8, width: 360, maxWidth: "100%", height: 160, background: "#fff" }}>
                                    <SignatureCanvas
                                        ref={(ref) => (this.sigPad = ref)}
                                        penColor="#1f2430"
                                        onEnd={this.handleSignatureEnd}
                                        canvasProps={{ style: { width: "100%", height: "160px" } }}
                                    />
                                </div>
                            </Fragment>
                        )}
                        <div>
                            <Button size="small" onClick={this.handleClearSignature} style={{ marginTop: 6, color: "#6b7280" }}>
                                Clear Signature
                            </Button>
                        </div>
                    </Grid>

                    {this.state.submitError && (
                        <Grid item xs={12}>
                            <Typography variant="body2" style={{ color: "#c62828", background: "#fff3f3", border: "1px solid #f5c6cb", borderRadius: 6, padding: "10px 14px" }}>
                                {this.state.submitError}
                            </Typography>
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            disabled={!this.isComplete() || this.state.isSubmitting}
                            style={{
                                backgroundColor: this.isComplete() && !this.state.isSubmitting ? HOT_PINK : undefined,
                                color: this.isComplete() && !this.state.isSubmitting ? "#fff" : undefined
                            }}
                            onClick={() => this.setState({ confirmDialogOpen: true })}
                        >
                            {this.state.isSubmitting
                                ? "Saving…"
                                : this.state.employerRegistered
                                    ? "Update Employer"
                                    : "Register as Employer"}
                        </Button>
                    </Grid>
                </Grid>

            </div>

            <Dialog
                open={this.state.confirmDialogOpen}
                onClose={() => this.setState({ confirmDialogOpen: false })}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    {this.state.employerRegistered ? "Update Employer Details" : "Register as Employer"}
                </DialogTitle>
                <DialogContent>
                    <Typography>
                        {this.state.employerRegistered
                            ? "Updating your employer information will trigger a new verification process with the clearing house. Your super contributions may be paused until verification is complete. Are you sure you want to continue?"
                            : "You are about to register as an employer with the clearing house. This will begin the verification process and allow you to make super contributions on behalf of your employees. Are you sure you want to proceed?"}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.setState({ confirmDialogOpen: false })}>
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        style={{ backgroundColor: HOT_PINK, color: "#fff" }}
                        onClick={() => {
                            this.setState({ confirmDialogOpen: false });
                            this.handleRegister();
                        }}
                    >
                        {this.state.employerRegistered ? "Confirm Update" : "Confirm Registration"}
                    </Button>
                </DialogActions>
            </Dialog>
            </React.Fragment>
        );
    }
}

export default EmployerSuperSetup;
